import React from 'react';

const PodcastIcon = () => (
  <svg width="40" height="39" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.072 28.81L7.6 31.44C2.95 27.595 0 21.985 0 15.719 0 9.451 2.95 3.841 7.602 0l2.471 2.627c-3.878 3.205-6.341 7.88-6.341 13.091 0 5.212 2.463 9.887 6.34 13.092zM25 15.72c0-2.894-2.24-5.24-5-5.24s-5 2.346-5 5.24c0 2.277 1.397 4.196 3.333 4.918v17.786h3.334V20.637C23.603 19.915 25 17.996 25 15.719zm-13.803 0c0-3.128 1.478-5.935 3.803-7.856L12.532 5.24c-3.1 2.562-5.067 6.3-5.067 10.479 0 4.177 1.967 7.916 5.067 10.479L15 23.574c-2.327-1.92-3.803-4.728-3.803-7.856zM32.4 0l-2.472 2.627c3.877 3.205 6.34 7.88 6.34 13.091 0 5.212-2.463 9.887-6.34 13.092L32.4 31.44c4.65-3.844 7.6-9.454 7.6-15.72C40 9.451 37.05 3.841 32.4 0zm-4.932 5.24L25 7.863c2.327 1.923 3.803 4.728 3.803 7.856 0 3.127-1.476 5.934-3.803 7.855l2.468 2.624c3.1-2.563 5.067-6.302 5.067-10.48 0-4.177-1.965-7.916-5.067-10.478z"
      fill="#fff"
    />
  </svg>
);

export default PodcastIcon;
